import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { CalendarDays } from "lucide-react";
import { BfgShell } from "@/game/gameShared";
import { useEventPageMeta } from "@/seo";
import "./board-fundraising-event-registration.css";

const API = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "") + "/api";
const client = axios.create({ baseURL: API, withCredentials: true });

export default function BoardFundraisingEventRegistrationPage() {
  const { eventId } = useParams();
  const [event, setEvent] = useState(null);
  const [form, setForm] = useState({ name: "", email: "", organization: "", role: "" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  useEventPageMeta("registration", event, null, eventId);
  useEffect(() => {
    setEvent(null); setError("");
    client.get("/admin/board-fundraising/public/events/" + encodeURIComponent(eventId))
      .then(r => setEvent(r.data.event)).catch(e => setError(e.response?.data?.detail || "The next live session will be announced here soon."));
  }, [eventId]);
  const submit = async e => {
    e.preventDefault(); setBusy(true); setError("");
    try {
      await client.post("/admin/board-fundraising/public/registrations", { ...form, event_id: event.event_id });
      window.location.assign("/board-fundraising/event-offer/" + encodeURIComponent(event.event_id));
    } catch (err) { setError(err.response?.data?.detail || "Your registration could not be completed."); setBusy(false); }
  };
  return <BfgShell><main className="bf-event-register"><section className="bf-event-register-card">
    <p className="bfg-eyebrow">NONPROFIT BOARD BUILDER · LIVE WITH ROONEY</p>
    {event ? <>
      <h1>{event.title}</h1>{event.subtitle && <h2>{event.subtitle}</h2>}
      <div className="bf-event-register-layout"><div className="bf-event-story">
      {event.photo_url && <figure className="bf-event-photo"><img src={event.photo_url.startsWith("/api/") ? (process.env.REACT_APP_BACKEND_URL || "") + event.photo_url : event.photo_url} alt="Rooney teaching nonprofit leaders at a live event" width={event.photo_width || 1373} height={event.photo_height || 1824} loading="eager" fetchPriority="high" decoding="async"/></figure>}
      <p className="bf-event-description">{event.description}</p>
      </div><div className="bf-event-register-form">
      <div className="bf-event-date"><CalendarDays size={20}/><span>{new Date(event.starts_at).toLocaleString("en-GB", { dateStyle: "full", timeStyle: "short", timeZone: event.timezone || "Europe/London" })} · {event.timezone}</span></div>
      <form onSubmit={submit}>
        {[["name", "Your name", "text", 160], ["email", "Email address", "email", 254], ["organization", "Organisation name", "text", 200], ["role", "Your role", "text", 160]].map(([key, label, type, max]) =>
          <label key={key}>{label}<input required type={type} minLength={key === "email" ? 5 : key === "name" ? 2 : 1} maxLength={max} autoComplete={key === "name" ? "name" : key === "email" ? "email" : key === "organization" ? "organization" : "organization-title"} value={form[key]} onChange={e => setForm({ ...form, [key]: e.target.value })}/></label>)}
        {error && <p role="alert" className="bf-event-error">{error}</p>}
        <button className="bfg-btn bfg-btn-primary" disabled={busy}>{busy ? "Registering…" : "JOIN THE LIVE SESSION"}</button>
        <p className="bf-event-privacy">We’ll email your joining details, event reminders and follow-up resources. You can unsubscribe from promotional emails at any time.</p>
      </form>
      </div></div>
    </> : <><h1>Join the Next Live Board Fundraising Session</h1><p role="status">{error || "Loading the next session…"}</p></>}
  </section></main></BfgShell>;
}
